
import React, { FC } from 'react';

const Spinner: FC<any> = ({ show, hideOverlay }) => {
    if (show) {
        return (
            <div className='spinner-loading-container d-flex align-items-center justify-content-center'>
                {!hideOverlay && <div className='bg-overlay'></div>}
                <div className="spinner-border m-5" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            </div>
        )
    }
    return <></>
}

export default Spinner;
